export const APPROVAL_STEP_RULE_ALL = 1;
export const APPROVAL_STEP_RULE_ANY = 2;
export const APPROVAL_STEP_RULE_NONE = 3;

export const APPROVAL_STEP_RULE_ALL_TEXT = 'All';
export const APPROVAL_STEP_RULE_ANY_TEXT = 'Any';
export const APPROVAL_STEP_RULE_NONE_TEXT = 'None';

export const approvalStepRuleOptions = [
  {
    value: APPROVAL_STEP_RULE_ALL,
    label: APPROVAL_STEP_RULE_ALL_TEXT
  },
  {
    value: APPROVAL_STEP_RULE_ANY,
    label: APPROVAL_STEP_RULE_ANY_TEXT
  }
  // {
  //  value: APPROVAL_STEP_RULE_NONE,
  //  label: APPROVAL_STEP_RULE_NONE_TEXT
  // }
];
